import { Box } from '@mui/system';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { getSessionStorage, SESSION_STORAGE_NAMES } from '@libs/storage/src/lib/session';
const BlankPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const timeout = setTimeout(() => {
      const url = getSessionStorage(SESSION_STORAGE_NAMES.INITIAL_URL);
      if (url && !url.includes('blank')) {
        navigate(url);
      } else {
        navigate('/myPage');
      }
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return (
    <Box>
      <CircularProgress />
      <h1>Loading Authorized Menus...</h1>
    </Box>
  );
};

export default BlankPage;
